"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuidv4 = void 0;
//For an RFC4122 version 4 compliant solution
// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
var uuidv4 = function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
exports.uuidv4 = uuidv4;